import { FunctionComponent } from 'react';
import { TileListStyle } from './TileList.style';

const TileList: FunctionComponent<React.PropsWithChildren<{}>> = ({ children }) =>
  children ? <TileListStyle data-testid="tileList">{children}</TileListStyle> : null;

export default TileList;
